import type { PlayerWithId } from '@/hooks/usePlayers';

/* =====================================================================
   leaderboard.ts — utilidades puras de ranking.
===================================================================== */

export interface CompanyAggregate {
  name: string;
  total: number;       // suma de scores total de todos los jugadores
  best: number;        // mejor score individual de la empresa
  count: number;       // # de jugadores
  avg: number;         // total / count, redondeado
  players: PlayerWithId[];
}

/** Ordena jugadores por total descendente, desempate por timestamp ascendente (llegó primero). */
export function sortByTotal(players: PlayerWithId[]): PlayerWithId[] {
  return [...players].sort((a, b) => {
    const diff = b.scores.total - a.scores.total;
    if (diff !== 0) return diff;
    return a.ts - b.ts;
  });
}

/** Agrupa por empresa, ordenado por promedio descendente. */
export function aggregateByCompany(players: PlayerWithId[]): CompanyAggregate[] {
  const map = new Map<string, CompanyAggregate>();
  for (const p of players) {
    const existing = map.get(p.company);
    if (existing) {
      existing.total += p.scores.total;
      existing.best = Math.max(existing.best, p.scores.total);
      existing.count++;
      existing.players.push(p);
    } else {
      map.set(p.company, {
        name: p.company,
        total: p.scores.total,
        best: p.scores.total,
        count: 1,
        avg: 0,
        players: [p],
      });
    }
  }
  const result = Array.from(map.values()).map((c) => ({
    ...c,
    avg: Math.round(c.total / c.count),
  }));
  return result.sort((a, b) => b.avg - a.avg);
}

/** Medalla por ranking 0-indexado. */
export function rankMedal(index: number): string {
  return index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : (index + 1).toString();
}

/** Clase CSS para el podio. */
export function podiumClass(index: number): string {
  return index === 0 ? 'top1' : index === 1 ? 'top2' : index === 2 ? 'top3' : '';
}
